import { render } from "./IncludedTransactions.vue?vue&type=template&id=a9848966&scoped=true&ts=true"
import script from "./IncludedTransactions.vue?vue&type=script&lang=ts"
export * from "./IncludedTransactions.vue?vue&type=script&lang=ts"

import "./IncludedTransactions.vue?vue&type=style&index=0&id=a9848966&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9848966"]])

export default __exports__